document.addEventListener('DOMContentLoaded', function () {
  new Choices('#choices-multiple-remove-button', {
    delimiter: ',',
    removeItemButton: true,
    noChoicesText: '選択されていません',
    itemSelectText: '選択してください',
    searchResultLimit: 100,
    noResultsText: '一致する検索結果はありませんでした'
  });
  new Choices('#choices-single', {
    delimiter: ',',
    placeholder: true,
    noChoicesText: '選択されていません',
    itemSelectText: '選択してください',
    searchResultLimit: 100,
    noResultsText: '一致する検索結果はありませんでした'
  });
});
